<template>
  <!-- Komponent do wyboru użytkownika z listy -->
  <div class="userId">
    <h4
      class="margin-0"
      :class="{
        // Jeśli wystąpił błąd i wymagane pole userId nie zostało uzupełnione – dodaj klasę text-danger (koloruje na czerwono)
        'text-danger':
          this.store.error &&
          (this.store.requireFields.includes('userId') ||
            this.store.requireFields.includes('userId')),
      }"
    >
      <!-- Nagłówek sekcji: "Nazwa użytkownika" -->
      {{ t('username') }}
    </h4>
    <!-- Select z listą użytkowników -->
    <select class="form-select" name="userId" v-model.lazy="value">
      <!-- Opcja domyślna: "Wszyscy użytkownicy" -->
      <option key="" value="">{{ t('all-users') }}</option>
      <!-- Generowanie opcji na podstawie store.users (tablica użytkowników) -->
      <option v-for="option in store.users" :key="option.id" :value="option.id">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  // Oczekuje przekazania obiektu store (Pinia store) jako prop
  props: {
    store: { required: true },
  },
  name: "UserFilter",
  setup(props) {
    // Reaktywna zmienna value, przechowuje aktualnie wybranego użytkownika (lub pustą wartość = wszyscy użytkownicy)
    const value = ref("");

    // Funkcja zapisująca wybór do store'a (Pinia) za pomocą metody addItem
    const saveValue = (text) => {
      props.store.addItem("userId", text);
    };

    // Watcher reaguje na zmianę value i wywołuje saveValue po każdej zmianie
    watch(value, (newValue) => {
      saveValue(newValue); // wywoływane tylko przy zmianach
    });

    // Zwracamy value do template
    return { value };
  },
  created() {
    // Po utworzeniu komponentu pobieramy użytkowników (jeśli jeszcze nie są pobrani)
    this.store.getUsers();
  },
};
</script>
<style scoped>
.userId {
  width: 280px;
}
.userId h4 {
  /* Wygląd nagłówka sekcji */
  padding: 8px 15px 5px;
  width: 100%;
  background: white;
  font-size: 16px;
  border-right: 1px solid #e1e1df;
}
.userId select {
  font-size: 12px;
  padding-left: 0.9rem;
}
</style>
